import { Image } from 'primereact/image';
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import Layout from "../../../components/common/nav/initiator/nav.component";
import { groupBy, orderBy, range } from "lodash";
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateInitiatorRole, } from '../../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../../assets/images/sidebarright.svg"
import user1 from "../../../assets/images/user1.svg"
import user2 from "../../../assets/images/user2.svg"
import Editpopup from "../../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../../setup/auth/login.component';
import sidebar from "../../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Avatar } from 'primereact/avatar';
import { ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForSelect } from '../../../helper/commonfunctions';
import {
  InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportStatus, Employee, Schools, Subject,
  SixthPeriodAssignmentInitiateReport, PSAConsultant, PSATransactionCycle, PersonnelActionTransactionCycle
} from "../../../models";
import w9DetailesPic from '../../../assets/svg/w9details.svg'
import moment from "moment";
import { Link } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { Calendar } from 'primereact/calendar';
import empDetailsImg from '../../../assets/images/applicationImg.png';
import { toast } from 'react-toastify';
import { Request_Status,PSA_Status, USER_TYPES, USER_TYPES_NAMES } from '../../../helper/enum';
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdf from '../../../components/HtmlToPdf';
import ServiceAgreementPdf from '../../../components/reportpdftemplate/serviceagreementpdf';
import '../../../components/reportpdftemplate/base.min.css'
import '../../../components/reportpdftemplate/fancy.min.css'
import '../../../components/reportpdftemplate/main.css'
import PreviewAgreement from '../../../../src/assets/images/stipend-form.jpg';
import { FilterMatchMode, } from 'primereact/api';
import { useFormik } from "formik";
import PsaPdf from '../../../components/reportpdftemplate/personalserviceagreementpdf';
import PsaTermsAndConditions from '../../../components/personalserivicet&c';
import ReactFullscreen from 'react-easyfullscreen';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import handleDateSelect from "../../../helper/convertDateIntoPSTFormat";



export default function ServiceAgreementInitiatorReportList() {
  const [StipendsFormFullScreen, setStipendsFormFullScreen] = useState(false);
  const [RejectReport, setRejectReport] = useState(false);
  const [RejectReport_Send, setRejectReport_Send] = useState(false);
  const [Report_Approved, setReport_Approved] = useState(false);

  //states start
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [initiatorReportList, setInitiatorReportList] = useState([]);

  const [approvalList, setApprovalList] = useState([]);
  console.log(approvalList,"App++++")
  //states end
  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharge, setAccountCharged] = useState('');
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState('');
  let [userList, setUserList] = useState([]);
  const [subjectCode, setSubjectCodeList] = useState(null);
  const [value, setValue] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [fteUtilized, setFteUtilized] = useState('');
  const [checked, setChecked] = useState(false);
  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState();
  const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
  const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
  const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
  const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
  const [activate, setActivate] = useState("");
  const [attchmentAndDetailes, SetAttchmentAndDetailes] = useState(false);
  const [termsAndConditions, SetTermsAndConditions] = useState(false);
  const [eddDetailes, SetEddDetailes] = useState(false);
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);
  const [pendingForApprovalCountForReqReportsCount, setPendingForApprovalCountForReqReports] = useState(0);
  const [approvedCountForReqReportsCount, setApprovedCountForReqReports] = useState(0);
  const [rejectCountForReqReportsCount, setRejectCountForReqReports] = useState(0);
  const [isLoading, setIsLoading] = useState(false)

  const [filters, setFilters] = useState({
    assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    period: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // remark: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
    </div>
  );
  //_____popup

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('');
  const [schoolList, setSchoolList] = useState('');
  const [schoolSelect, setSelectedSchool] = useState('');
  const [partyDetailesPopup, setPartyDetailesPopUp] = useState(false);
  const [budgetClerk, setBudgetClerk] = useState(null);
  const [hrConsultant, setHrConsultant] = useState(null);

  const [executiveApprover, setExecutiveApprover] = useState(null);
  const [hrSecreatary, setHrSecreatary] = useState(null);
  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assighnmentTitle, setAssighnmentTitle] = useState('');
  const [w9Detailes, SetW9Detailes] = useState(false);
  const [submittedTo, setSubmittedTo] = useState(null)
const [approvelStatusData, setApprovelStatusData] = useState([])  
  const currentDateTime = moment();

  // console.log(loggedUserId,"loggedUserId");


  

  const itemTemplate = (country) => {
    // Customize how the dropdown items are displayed
    return (
      <div>
        {country.name} - {country.code}
      </div>
    );
  };
  const [items, setItems] = useState([]);
  const handleKeyUp = (event) => {
    const query = event.query;
    //console.log(event)

    let filteredData = empCodeList.filter((item) =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );

    filteredData = filteredData.map(item => item.name)
    console.log(filteredData)
    setItems(filteredData)
    //setFilteredItems(filteredData);
  };

  const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmitted']);


  const initiatordata = [
    {
      srNo: '01',
      assignmentTitle: 'Tile01',
      period: '1',
      submittedOn: 'ON',
      remark: 'Yes'
    },
    {
      srNo: '01',
      assignmentTitle: 'Title02',
      period: '2',
      submittedOn: 'Yes',
      remark: 'No'
    },
  ]

  const TaskStatusSL = (product) => {
    switch (product.status) {
      case 'Reviewed & resubmitted':
        return 'info';

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'SUBMITTED':
        return 'info';
      case 'OPEN':
          return 'info';
      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';

      default:
        return null;
    }
  };

  const TaskStatusSLA = (product) => {
    return <><Badge value="" severity={TaskStatusSL(product)}></Badge> {product.status}</>;
  };

  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const [PSAview, setPSAview] = useState(false);
  const [PSAedit, setPSAedit] = useState(false);

  const [formData, setFormData] = useState({})
  const [department, setDepartment] = useState(null)

  const formik = useFormik({
    initialValues: {},
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      console.log('data 👍👍👍👍', data)
      setFormData(data)
    }
  });


  
  const alljobactionContent = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >
        <div className='cursor-pointer' onClick={() => setPSAview(true)}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></div>
        <div className='cursor-pointer' onClick={() => {
          onClickHandleEdit(row, row.pstatus)
          }}><i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i></div>


        {/* {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickEditPopUp(row)
                  }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        } */}
      </div>
    );
  };


   const approveSelectedReport = async reportId => {
	    const PSAConsultantData = await DataStore.query(PSAConsultant, c =>
        c.id.eq(reportId)
      );
	  // dateTime : new Date().toString()
	   const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId));
		
		//fetch all approver
		// let teacher = PSAConsultant[0].employee_id;
            let secondApprover = PSAConsultantData[0].budgetClerk;
            let thirdApprover = PSAConsultantData[0].hrConsultant;
            let fourthApprover = PSAConsultantData[0].executive;
            let fifthApprover = PSAConsultantData[0].hrexecutive;
            // let payrollId = PSAConsultant[0].payrollId;
            // let sixthApprover =  financeAnalyst?.userId ?? 0;

            var toEmployeeId = "";
			var psaStatus = PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK
		 switch (loggedUserId) {
              //reporting manager.
              case secondApprover:
                  toEmployeeId = thirdApprover;
				  psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION
                break;
              case thirdApprover:
                  toEmployeeId = fourthApprover;
				  psaStatus = PSA_Status.PENDING_FOR_APPROVAL_EXECUTIVE_APPROVER
                break;
              case fourthApprover:
                  toEmployeeId = fifthApprover;
				  psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY
                break;
              case fifthApprover:
                  toEmployeeId = 'NO_APPROVAL';
				  psaStatus = PSA_Status.APPROVED;
                break;
				
				 default:
                // Assign a default variable value if the logged user is not an approver
                toEmployeeId = 'NO_APPROVAL';//PSAConsultantData[0].payrollId;
				psaStatus = PSA_Status.APPROVED
                break;	
			}
			
			if(toEmployeeId === 'NO_APPROVAL'){
				
				await DataStore.save(
          PSATransactionCycle.copyOf(original[0], updated => {
                    updated.isApproved = true;
                    updated.status = psaStatus;  
                    // updated.signature_File_Path = signaturePath;
                  })
                )
				
			}else{
			 await DataStore.save(
        PSATransactionCycle.copyOf(original[0], updated => {
                    updated.isApproved = true;
                    updated.status = "Approved";  
                    // updated.signature_File_Path = signaturePath;
                  })
                
                ).then(async () => {

                  //after we add another row for save
                  const addNewRowForRMReasponse = await DataStore.save(
                    new PSATransactionCycle({
                      report_Id: reportId,
                      from_Employee_Id: loggedUserId,
                      to_Employee_Id: toEmployeeId,
                      status: psaStatus,    //// pending for approval 
                      isApproved: false,
                      remark: "",
                      date: moment().format("YYYY-MM-DD"),
					  dateTime: moment().toISOString()
                    })
                  );
                 await DataStore.save(
                    PSAConsultant.copyOf(PSAConsultantData[0], updated => {
                      updated.status = "Approved";  
                      // updated.signature_File_Path = signaturePath;
                    })
                  );
				});
	   
			}
			
			
	  }


  //* onclick view popup
  const onClickViewPopup = async (requestData, position) => {
    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized,
    }
    setSpecificReportDetailsView(obj);
  }





  const onClickHandleEdit = async (requestData, currentstatus) => {
    setIsLoading(true)
    const PSAConsultantData = await DataStore.query(PSAConsultant, requestData.id);
    let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, PSAConsultantData.report_Id);
    PSATransactionCycleData = PSATransactionCycleData.map(res => {
      const asigneeData = getAssigneeName(res)
      return({...res,assigneeData : asigneeData  })
    })
    
    setApprovelStatusData(PSATransactionCycleData.map(res => ( {
      id: res?.id,
      title: res?.assigneeData?.userCode,
      name: res?.assigneeData?.assigneeName,
      status: res?.isApproved ? "Approved" : res?.status,
      updatedAt: handleDateSelect(res?.updatedAt),
    })))
    setSpecificReportDetailsEdit({PSAConsultantData:PSAConsultantData[0],PSATransactionCycleData:PSATransactionCycleData[0]})
    if (requestData) {
      console.log(requestData);

      //set manager data employee
      var newRes = [];
      let userRole = "",
        userName = "",
        userEmail = "",
        userCode = "",
        userReportingManager = "",
        sub="";

      //console.log("usersusersusers:-", users);

      users.forEach((user, i) => {
        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
        userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
        userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
        userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
        userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
        userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;

        let obj = {
          userId: sub,
          name: userName,
          email: userEmail,
          usercode: userCode,
          role:
            userRole === USER_TYPES.SUPERADMIN
              ? USER_TYPES_NAMES.SA
              : userRole === USER_TYPES.ADMIN
                ? USER_TYPES_NAMES.A
                : userRole === USER_TYPES.APPROVER
                  ? USER_TYPES_NAMES.AP
                  : userRole === USER_TYPES.PAYROLL
                    ? USER_TYPES_NAMES.P
                    : USER_TYPES_NAMES.I,
          userReportingManager: userReportingManager
        };
        newRes.push(obj);
      });

      //get only those users are without admin
      let usersWithoutAdmin = [];
      const loggedUserId = reactLocalStorage.get("loggedUserId");
      //console.log("INITIATE loggedUserIdloggedUserId:-", loggedUserId);

      //console.log("INITIATE newResnewResnewRes:-", newRes);

      newRes.map(currentItem => {
        if (currentItem.role !== "Admin" && currentItem.userId !== loggedUserId) {
          usersWithoutAdmin.push(currentItem);
        }
      });

      console.log("INITIATE usersWithoutAdminusersWithoutAdmin:-", usersWithoutAdmin);
      //set employee list
      let finalEmpList = [];

      users.map(currentItem => {
        const getName = () => {
          try {
            let fname = currentItem.Attributes.filter(a => a.Name === 'custom:firstName' ? a.Value : "");
            let lname = currentItem.Attributes.filter(a => a.Name === 'custom:lastName' ? a.Value : "");
            return fname[0].Value + " " + lname[0].Value
          } catch (e) { }
          return "";
        }
        const getUsercode = () => {
          try {
            let usercode = currentItem.Attributes.filter(a => a.Name === 'custom:userCode' ? a.Value : "");
            return usercode[0].Value
          } catch (e) { }
          return "";
        }
        const getUserId = () => {
          try {
            let userId = currentItem.Attributes.filter(a => a.Name === 'sub' ? a.Value : "");
            return userId[0].Value
          } catch (e) { }
          return "";
        }
        let obj = { name: `${getName()} (${getUsercode()})`, code: getUserId(), userCode: getUsercode(), label: getName() };
        finalEmpList.push(obj);
      });
      setEmpCodeList(finalEmpList);
      setAllEmployeeDetails(usersWithoutAdmin);


		
      }
      //-----------------------------------------
      setIsLoading(false)
      setPSAedit(true);
    }
  
    // const getCognitoUserList = (e, listName) => {
    //   try {
    //     const cognito = new AWS.CognitoIdentityServiceProvider();
  
    //     var params = {
    //       UserPoolId: awsmobile.aws_user_pools_id
    //       // Limit: 60,
    //       // Filter: 'name ^= "' + e.target.value + '"'
    //     };
    //     cognito.getUser(params,(err,data) => {
    //       console.log("🚀 ~ file: index.js:513 ~ cognito.getUser ~ err:", err)
    //       console.log("🚀 ~ file: index.js:513 ~ cognito.getUser ~ data:", data)
        
    //     })
    //     // cognito.listUsers(params, (err, data) => {
    //     //   if (err) {
    //     //     //(err.message);
    //     //   } else {
    //     //     let usersData = [];
    //     //     //let adminUsers = data.Users
    //     //     var role = "";
    //     //     var name = "";
    //     //     var email = "";
    //     //     var usercode = "";
  
    //     //     data.Users.forEach((user, i) => {
    //     //       role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
    //     //       name = user.Attributes.find(attr => attr.Name === "name")?.Value;
    //     //       email = user.Attributes.find(attr => attr.Name === "email")?.Value;
    //     //       usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
    //     //       name = usercode ? `${name} (${usercode})` : name;
    //     //       let newUser = {
    //     //         code: user?.Username,
    //     //         name: name,
    //     //         email: email,
    //     //         // code: user?.Username,
    //     //         role:
    //     //           role === USER_TYPES.ADMIN
    //     //             ? USER_TYPES_NAMES.A
    //     //             : role === USER_TYPES.APPROVER
    //     //             ? USER_TYPES_NAMES.AP
    //     //             : role === USER_TYPES.PAYROLL
    //     //             ? USER_TYPES_NAMES.P
    //     //             : USER_TYPES_NAMES.I
    //     //       };
  
    //     //       usersData.push(newUser);
  
    //     //       // usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
    //     //     });
    //     //     // setUserData(usersData);
    //     //   }
    //     // });
    //   } catch (e) {
    //     console.log("🚀 ~ file: PersonalsServiceagreementModal.js:329 ~ getCognitoUserList ~ e:", e);
    //     //toast.error(e.message);
    //   }
    // };

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  const saveBasicInfo = async (type) => {

    // if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
    // else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
    // else if (assighnmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
    // else if (startDate === null) { toast.error('Please enter From Date'); return; }
    // else if (endDate === null) { toast.error('Please enter To Date'); return; }
    // else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

    var updatedSchoolId;

    //Save Basic Info

    //check type
    console.log('formData 😂😂😂😂', formData)
    if (type === 'save') {
      // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
      //   "assignment_title": assighnmentTitle,
      //   "employee_id": selectedEmployee.name,
      //   "assighment_at": schoolSelect.name,
      //   "from_date": moment(startDate).format("YYYY-MM-DD"),
      //   "to_date": moment(endDate).format("YYYY-MM-DD"),
      //   "subject_area": subjectCode.name,
      //   "total_staffing_allocation": totalStaffingAllocationectedRole,
      //   "account_charged": accountCharge,
      //   "current_fte_utilized": fteUtilized,
      //   "status": Request_Status.P,
      // })
      // );
      console.log('formData.assighnmentTitle 👍👍👍👍👍', formData)
      console.log('formData.assighnmentTitle 👍👍👍👍👍', formData.assignmentTitle)
      var newPSAConsultant = await DataStore.save(new PSAConsultant(
        {
          assignmentTitle: formData.assignmentTitle,
          department: formData?.department?.code,
          amount: formData.amount,
          expireDate: formData.expireDate && moment(formData.expireDate).format("YYYY-MM-DD"),
          notifyDays: formData.notifyDays && moment(formData.notifyDays).format("YYYY-MM-DD"),
          accountNo: formData.accountNo,
          boardItem: formData.boardItem,
          services: formData.services,
          agreementDate: formData.agreementDate && moment(formData.agreementDate).format("YYYY-MM-DD"),
          effectiveDate: formData.effectiveDate && moment(formData.effectiveDate).format("YYYY-MM-DD"),
          reviewDate: formData.reviewDate && moment(formData.reviewDate).format("YYYY-MM-DD"),
          submittedTo: formData.submittedTo?.name,
          dateofboard: formData.dateofboard && moment(formData.dateofboard).format("YYYY-MM-DD"),
          pageItem: formData.pageItem,
          email: formData.email,
        }
      ))
      console.log("🚀 ~ file: index.js:299 ~ saveBasicInfo ~ newPSAConsultant: 👍👍👍👍👍👍", newPSAConsultant)
    } else {
      //other wise status submit
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
        "assignment_title": assighnmentTitle,
        "employee_id": selectedEmployee.name,
        "assighment_at": schoolSelect.name,
        "from_date": moment(startDate).format("YYYY-MM-DD"),
        "to_date": moment(endDate).format("YYYY-MM-DD"),
        "subject_area": subjectCode.name,
        "total_staffing_allocation": totalStaffingAllocationectedRole,
        "account_charged": accountCharge,
        "current_fte_utilized": fteUtilized,
        "submited_by": loggedUserId,
        "submited_at": moment(currentDateTime).format("YYYY-DD-MM"),
        "status": Request_Status.S,
      })
      );
    }

    // updatedSchoolId = newSixthPeriodAssignmentInitiateReport.id;

    if (newPSAConsultant) {
      toast.success('Data Added Successfully.');
      BindList();
    }
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });


  //*get getEmployeeResponse
  const getEmployeeResponse = (id) => {
    let _employeeList = [...employeeList];
    var returnRecord = _employeeList.find(o => o.id === String(id));
    if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
  }

  const getAssigneeName = (data) => {
    try {
      let assigneeId = data?.to_Employee_Id;
      let assigneeName;
      let userCode;
      try {
        let x = users.filter(u => u.Username === assigneeId);
        console.log("🚀 ~ file: index.js:677 ~ getAssigneeName ~ x:", x)
        console.log("🚀 ~ file: index.js:677 ~ getAssigneeName ~ users:", users)
        let fname = x[0]?.Attributes.filter(u => u?.Name === 'custom:firstName');
        let lname = x[0]?.Attributes.filter(u => u?.Name === 'custom:lastName');
        userCode = x[0]?.Attributes.filter(u => u?.Name === 'custom:userCode')[0]?.Value;
        if (fname) {
          assigneeName = fname[0].Value;
        }
        if (lname) {
          assigneeName += " " + lname[0].Value;
        }
      } catch (e) {
        console.info(e)
      }
      return {assigneeName,userCode} || '-';
    } catch (e) {
      console.log(e);
      return '-';
    }
  }

  //Get PSAConsultant List
  const BindList = async () => {

    //Approver
    try {
      //2.fetch those request which needs approval for logged users.
      let PSAConsultantTransactionCycleResponse = await DataStore.query(
        PSATransactionCycle,
        c => c.to_Employee_Id.eq(loggedUserId),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

      // const original = await DataStore.query(PSAConsultant, report_Id);
      let PSAConsultantTransactionCycleGroupBy = groupBy(PSAConsultantTransactionCycleResponse, "report_Id");

      // console.log(PSAConsultantTransactionCycleResponse, "approvalList psa ");
      // console.log(PSAConsultantTransactionCycleGroupBy, "approvalList---");


      if (PSAConsultantTransactionCycleGroupBy) {
        let pendingCount = 0;
        let approvedCount = 0;
        let rejectCount = 0;
        let approvalFinalData = [];
        let i = 0;
        // for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
        for (let report_Id in PSAConsultantTransactionCycleGroupBy) {
          const currentItem = PSAConsultantTransactionCycleGroupBy[report_Id][0];

        // console.log(report_Id,"currentItem");

          //get Report data using report id
          const PSAConsultantTransactionCycleResponse = await DataStore.query(PSAConsultant, c =>
            c.id.eq(report_Id)
          );
          console.log("🚀 ~ file: index.js:665 ~ BindList ~ PSAConsultantTransactionCycleResponse: 😀😀😀😀", PSAConsultantTransactionCycleResponse)


        console.log(PSAConsultantTransactionCycleResponse,"PSA ---->")

          let obj = {
            srNo: i + 1,
            assignmentTitle: PSAConsultantTransactionCycleResponse[0].assignmentTitle ? PSAConsultantTransactionCycleResponse[0].assignmentTitle : '',
            // period: '',
            submittedOn: PSAConsultantTransactionCycleResponse[0].createdAt ? moment(PSAConsultantTransactionCycleResponse[0].createdAt).format("MM/DD/YYYY") : '',
            remark: PSAConsultantTransactionCycleResponse[0].otherRemark ? PSAConsultantTransactionCycleResponse[0].otherRemark : '',
            status: PSAConsultantTransactionCycleResponse[0].status ? PSAConsultantTransactionCycleResponse[0].status : '',
          }

          approvalFinalData.push(obj);

        }

        setApprovalList(approvalFinalData)


      }


    } catch (error) {
      console.log('Error for bindList', error);
    }


    var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    setSubjectCodeList(SubjectCodeResponses)
    var myArray = []; myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses); setSubjectListDropdown(myArray);


    var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);


    var employeeList = await DataStore.query(Employee, Predicates.ALL, {
      sort: s => s.employee_name(SortDirection.ASCENDING)
    });
    setEmployeeList(employeeList)

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
      }
    });

  }
 
  

  useEffect(() => {
    // onLoad();
    BindList();
  }, []);

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };



  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (
          <Layout pageTitle="Report" activeMenu="Initiator" appId="PSA">
          {!isLoading ?  <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
              <div className="flex justify-end visible lg:hidden">
                <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                <div className="relative z-10 col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                    <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                      <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Personal Service Agreement</p>

                      <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                        <Link to="" onClick={() => {
                          onToggle();
                        }}> <i className="gusd-expand"></i></Link>
                      </div>
                    </div>

                    <div>
                      {/* <TabView> */}

                      {/* <TabPanel header="Requested Reports"> */}
                      <div className="initiator">
                        <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                          filters={filters}
                          filterDisplay="row"
                          value={approvalList}
                          paginator responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}>
                          <Column field="srNo" header="SL#" sortable style={{ minWidth: '3rem' }}></Column>
                          <Column field="assignmentTitle" filters header="Assignment Title" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                          {/* <Column field="period" filters header="Period" sortable filter filterPlaceholder='Search'></Column> */}
                          <Column field="submittedOn" filters header="Submitted On" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                          <Column field="status" header="Status" body={TaskStatusSLA} filter filterElement={statusRowFilterTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                          <Column field="remark" header="Remarks" align='center' sortable style={{ minWidth: '6rem' }}></Column>
                          <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                        </DataTable>
                      </div>
                      {/*</TabPanel> */}
                      {/* </TabView> */}
                    </div>



                    <Dialog className="relative reports-popup" visible={visible} position={position}
                      style={{ width: '80vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                      <div className="grid grid-cols-1 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                          <div className="p-5">
                            <div onClick={() => setVisible(false)} className="py-3">
                              <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                            {
                              (!fullViewForView) ?
                                <div className=''>
                                  <div className='text-center'>
                                    <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Request For Approval - Sixth Period Teaching Assignment</div>
                                  </div>

                                  <div className='pt-3'>
                                    <p>Approval Status</p>
                                    <div className="py-3 emp-simple-tbl">
                                      <DataTable
                                        value={[
                                          {
                                            id: '1000',
                                            title: 'Principal',
                                            name: 'Alrick Barwa',
                                            status: 'Approved'
                                          },
                                          {
                                            id: '1001',
                                            title: 'Teacher',
                                            name: 'John Mishra',
                                            status: 'Approved'
                                          },
                                          {
                                            id: '1002',
                                            title: 'EAFE Program Administrator',
                                            name: 'Alrick Barwa',
                                            status: 'Approved'
                                          }

                                        ]}>
                                        <Column field="title" header="Title"></Column>
                                        <Column field="name" header="Name"></Column>
                                        <Column field="status" header="Status"></Column>
                                      </DataTable>
                                    </div>
                                  </div>

                                </div>

                                : null
                            }


                            <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf</div>
                                <button onClick={() => { (!fullViewForView) ? setFullViewForView(true) : setFullViewForView(false) }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>{(!fullViewForView) ? 'View Full Screen' : 'Exit Full Screen'} </button>
                              </div>

                              <div className="grid grid-cols-1">
                                {/* <img src={pdfImage} alt='myImg' /> */}
                                {/* <HtmlToPdf
                              data={{
                                'employeeName': 'Abc',
                                'employeeId': selectedEmployee.name,
                                'schoolName': schoolSelect.name,
                                'dateFrom': moment(startDate).format("YYYY-DD-MM"),
                                'dateTo': moment(endDate).format("YYYY-DD-MM"),
                                'subjectName': subjectCode.name,
                                'staffAllocation': totalStaffingAllocationectedRole,
                                'accountCharged': accountCharge,
                                'fteUtilized': fteUtilized
                              }}
                            /> */}
                                {/* <PsaPdf
                                  agreementDate='26/09/98'
                                  partyName='BlueOrbit'
                                  amount='2016'
                                  services='lunch dinner free'
                                  effectiveDate='02/09/1998'
                                  expirationDate='06/09/1998'
                                  typeOfBusinessEntityAandN='Insaurance Form'
                                  submittedTo='30/06/2023'
                                  referenceNo='33'

                                  // PSA Consultant details
                                  typeOfBusinessEntityPartyDetails='Individual'
                                  licenseNumber='LE02145'
                                  addressPSa='USA'
                                  psaDate='03/25/2024'
                                  contactNumber='9823456988'
                                  fax='66665'

                                  //Tax Identification Details
                                  socialSecurityNumber='30'
                                  employerIdentification='This is Employer Identification'

                                  //Gusd Detailes
                                  gusdDate='02/12/2023'
                                  accountNumber='98745211'
                                  dateOfBoardMeeting='26/09/98'
                                  BoardItem='Board'
                                  pageItem='page'
                                  superintendentAssistent='Mahesh'
                                /> */}
                              </div>
                            </div>




                            <div className='grid grid-cols-2 gap-4'>
                              <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                              </div>

                              <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">Yesterday</div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src={user1} alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhon Paul</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                </div>
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src={user2} alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhoana Maria</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user3.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jennifer Lopez</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                </div>
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user4.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Lethicia Jhansen</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user5.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhon Doe</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog>

                    {/* edit popup start */}
                    < Dialog className="relative reports-popup" visible={visibleEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleEdit(false)} draggable={false} resizable={false} >
                      <div className="">
                        <div className="bg-[#F5F6F7] relative h-screen">
                          <div className="p-5">
                            <a to='' onClick={() => setVisibleEdit(false)} className="py-3"><Image
                              src={sidebar} alt="user" width="24" height="24" /></a>


                            {
                              (!fullViewEdit) ?
                                <div>
                                  <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">Personal Service Agreement</div>
                                  <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                                  <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                      <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                      <div className="py-3 emp-simple-tbl">
                                        <DataTable
                                          value={[
                                            {
                                              id: '1000',
                                              title: 'Principal',
                                              name: 'Alrick Barwa',
                                              status: 'Approved'
                                            },
                                            {
                                              id: '1001',
                                              title: 'Teacher',
                                              name: 'John Mishra',
                                              status: 'Approved'
                                            },
                                            {
                                              id: '1002',
                                              title: 'EAFE Program Administrator',
                                              name: 'Alrick Barwa',
                                              status: 'Approved'
                                            }

                                          ]}>
                                          <Column field="title" header="Title"></Column>
                                          <Column field="name" header="Name"></Column>
                                          <Column field="status" header="Status"></Column>
                                        </DataTable>
                                      </div>
                                    </div>
                                  </div>
                                </div> : null
                            }



                            <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                              {
                                (!fullViewEdit) ?
                                  <div className='flex justify-between'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period.pdf</div>
                                    <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                  </div> :
                                  <div className='flex justify-between'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                    <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                  </div>
                              }

                              {
                                (!fullViewEdit) ?
                                  <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                    {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                    <HtmlToPdf
                                      data={{
                                        'employeeName': 'Abc',
                                        'employeeId': specificReportDetailsEdit.employee_id,
                                        'schoolName': specificReportDetailsEdit.assighment_at,
                                        'dateFrom': specificReportDetailsEdit.from_date,
                                        'dateTo': specificReportDetailsEdit.to_date,
                                        'subjectName': specificReportDetailsEdit.subject_area,
                                        'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                        'accountCharged': specificReportDetailsEdit.account_charged,
                                        'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                      }}
                                    />
                                  </div> :
                                  <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                    {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                    <HtmlToPdf
                                      data={{
                                        'employeeName': 'Abc',
                                        'employeeId': specificReportDetailsEdit.employee_id,
                                        'schoolName': specificReportDetailsEdit.assighment_at,
                                        'dateFrom': specificReportDetailsEdit.from_date,
                                        'dateTo': specificReportDetailsEdit.to_date,
                                        'subjectName': specificReportDetailsEdit.subject_area,
                                        'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                        'accountCharged': specificReportDetailsEdit.account_charged,
                                        'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                      }}
                                    />
                                  </div>
                              }
                            </div>
                          </div>



                          <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                            <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                              //  onClick={() => setVisibleCreteReportPopup(false)}
                              onClick={() => setConfirmVisible(true)}
                            ><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>

                            <Link to='' className=" text-center flex items-center tableBtn blue radius8"
                              //  onClick={() => saveGroupInfo()}
                              onClick={() => setConfirmVisible(true)}
                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Submit</Link>

                          </div>
                        </div>
                      </div>
                    </Dialog>

                    {/* confirmation dialog */}

                    <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                      <p className="m-0 text-[#0487C8]">
                        <i className='pi pi-check-circle mr-2'></i>
                        <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                      </p>
                    </Dialog>
                    {/* edit popup end */}

                  </div>

                  <Sidebar visible={visibleRight} position="right" onHide={() =>
                    setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                    <Editpopup popupstate={() => setVisibleRight(false)}
                      fromDate={fromDate}
                      toDate={toDate}
                      schoolName={schoolName}
                      reportEmployeeList={reportEmployeeList}
                      status={status}
                      reportId={reportId}
                      bindList={() => BindList()}
                      type={"Initior"}
                    />

                  </Sidebar>
                </div>
              </div>
            </div> :  <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                                                            <ProgressSpinner />
                                                        </div>}


            {/* popup's */}
            <Dialog className="relative reports-popup" visible={visibleCreteReportPopup} position="right" style={{ width: '30vw' }
            } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleCreteReportPopup(false)} draggable={false} resizable={false} >
              <div className="">
                <div className="bg-[#F5F6F7] relative h-screen">
                  <div className="p-5">
                    <a to='' onClick={() => setVisibleCreteReportPopup(false)} className="py-3"><Image
                      src={sidebar} alt="user" width="24" height="24" /></a>
                    <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">Personal Service Agreement</div>
                    {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                    <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                      <div className="mb-1">
                        <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Assignment Title</label>
                        <div><InputText
                          value={groupName}
                          onChange={e => setGroupName(e.target.value)}
                          id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                    <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={() => setVisibleCreteReportPopup(false)}><i className="pi pi-times mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                    <Link to='' className=" text-center flex items-center tableBtn blue radius8" onClick={() => {
                      setShowNextPopUp(true);
                      // saveGroupInfo();
                    }}><i className="pi pi-arrow-right mr-1" style={{ fontSize: '1rem' }}></i>Next</Link>

                  </div>
                </div>
              </div>
            </Dialog>
            <Sidebar className='PSAviewPopup' visible={PSAview} position="right" onHide={() => setPSAview(false)} style={{ width: '60vw', background: '#F5F6F7' }}>
              <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
                <div className='cursor-pointer mb-[20px]' onClick={() => setPSAview(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div> 

                <div className='text-black font-bold xl:text-[1.406vw] text-[25px]'>GLENDALE UNIFIED SCHOOL DISTRICT</div>
                <div className='text-black font-normal xl:text-[0.938vw] text-[16px]'>Request For Approval - Personal Service Agreement</div>

                <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
                  <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                    <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement.pdf </span>
                  </div>
                </div>

                <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
                  <div className='lg:h-[25vw] h-[450px] overflow-auto'>
                    <PsaPdf
                      agreementDate={specificReportDetailsEdit?.PSAConsultantData?.agreementDate}
                      partyName='BlueOrbit'
                      amount={specificReportDetailsEdit?.PSAConsultantData?.amount}
                      services={specificReportDetailsEdit?.PSAConsultantData?.services}
                      effectiveDate={specificReportDetailsEdit?.PSAConsultantData?.effectiveDate}
                      expirationDate={specificReportDetailsEdit?.PSAConsultantData?.expirationDate}
                      typeOfBusinessEntityAandN='Insaurance Form'
                      submittedTo={specificReportDetailsEdit?.PSAConsultantData?.submittedTo}
                      referenceNo='33'

                      // PSA Consultant details
                      typeOfBusinessEntityPartyDetails='Individual'
                      licenseNumber='LE02145'
                      addressPSa='USA'
                      psaDate='03/25/2024'
                      contactNumber='9823456988'
                      fax='66665'

                      //Tax Identification Details
                      socialSecurityNumber='30'
                      employerIdentification='This is Employer Identification'

                      //Gusd Detailes
                      gusdDate='02/12/2023'
                      accountNumber={specificReportDetailsEdit?.PSAConsultantData?.accountNumber}
                      dateOfBoardMeeting={specificReportDetailsEdit?.PSAConsultantData?.dateofboard}
                      BoardItem={specificReportDetailsEdit?.PSAConsultantData?.boardItem}
                      pageItem={specificReportDetailsEdit?.PSAConsultantData?.pageItem}
                      superintendentAssistent='Mahesh'
                    />

                  </div>
                </div>

                <div className='grid grid-cols-2 mt-[20px] gap-[14px]'>
                  <div><Link to={''} className='text-[#344054] font-medium text-xs xl:text-[0.833vw] bg-white border border-[#D0D5DD] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='gusd-print-outline'></i><span>Print</span></Link></div>
                  <div><Link to={''} className='text-[#FFFFFF] font-medium text-xs xl:text-[0.833vw] bg-[#113699] border border-[#113699] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='Download_WhiteIcon'></i><span>Download</span></Link></div>
                </div>

              </div>
            </Sidebar>


            <Sidebar className='PSAviewPopup' visible={PSAedit} position="right" onHide={() => setPSAedit(false)} style={{ width: '35vw', background: '#F5F6F7' }}>
              <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px] lg:space-y-[1.250vw] space-y-2'>
                {/*col*/}
                <div className='cursor-pointer mb-[20px]' onClick={() => setPSAedit(false)}><i className='gusd-close-sidebar'></i></div>
                {/*col*/}
                <div>
                  <div className='text-[#113699] font-semibold text-sm xl:text-[0.938vw]'>Glendale Unified School District</div>
                  <div className='text-[#344054] font-normal text-xs xl:text-[0.677vw]'>Personal Service Agreement </div>
                </div>
                {/*col*/}
                <div className='bg-[#EFF0F1] p-4 xl:p-[0.885vw]'>
                  <div className='text-[#344054] font-semibold text-xs xl:text-[0.677vw]'>Approval Status</div>
                  <div className='bg-white p-2 xl:p-[0.469vw] rounded-lg mt-[8px]'>
                    <table class="table-auto w-full">
                      <thead>
                        <tr className='text-[#667085] text-xs py-2 px-2 inline-block'>
                          <th align='left' width={200} className='font-medium'>Title</th>
                          <th align='left' width={130} className='font-medium'>Name</th>
                          <th align='left' width={150} className='font-medium'>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          approvelStatusData?.length > 0 && approvelStatusData.map(res => {
                            let labelStyle 
                            switch (res?.status) {
                              case "Approved":
                                labelStyle = "bg-[#E5F3EC] text-[#029046]"
                                break;
                              case "Pending for HR Consultant Clearance Verification":
                                labelStyle = "bg-[#E5F3EC] text-[#029046]"
                                break;
                              case "Pending for Review":
                                labelStyle = "bg-[#FFF2E5] text-[#FF7F01]"
                                break;
                              case "Rejected":
                                labelStyle = "bg-[#FEF3F2] text-[#D92D20]"
                                break;
                              default:
                                labelStyle = "bg-[#E5F3EC] text-[#029046]"
                                break;
                            }
                            return(
                              <tr className='text-[#344054] text-xs font-normal py-2 px-2 inline-block border-b border-[#E4E7EC]'>
                                <td align='left' width={200}>{res.title}</td>
                                <td align='left' width={130}>{res.name}</td>
                                <td align='left' width={150}><div className={`${labelStyle} text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center`}><i className='pi pi-circle-fill' style={{ fontSize: '8px' }}></i><span>{res.status}</span></div></td>
                              </tr>
                              )
                          }) 
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                {/*col*/}
                <div>
                  <div className='xl:p-[1.042vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between'>
                    <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                      <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement

                        .pdf</span>
                    </div>
                    <div className='text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer' onClick={() => setStipendsFormFullScreen(true)}><span className='view_full_screen block w-[18px] h-[18px]'></span><span>View Full Screen</span></div>
                  </div>

                  <div className='xl:p-[1.250vw] p-[20px] bg-[#EFF0F1] rounded-md'>
                    <div className='lg:h-[10.938vw] h-[242px] overflow-auto'>
                      {/* <Image src={PreviewAgreement} width={"473"} height={"612"} alt='preview-agreement' /> */}
                      {/* <PsaPdf
                        agreementDate='26/09/98'
                        partyName='BlueOrbit'
                        amount='2016'
                        services='lunch dinner free'
                        effectiveDate='02/09/1998'
                        expirationDate='06/09/1998'
                        typeOfBusinessEntityAandN='Insaurance Form'
                        submittedTo='30/06/2023'
                        referenceNo='33'

                        // PSA Consultant details
                        typeOfBusinessEntityPartyDetails='Individual'
                        licenseNumber='LE02145'
                        addressPSa='USA'
                        psaDate='03/25/2024'
                        contactNumber='9823456988'
                        fax='66665'

                        //Tax Identification Details
                        socialSecurityNumber='30'
                        employerIdentification='This is Employer Identification'

                        //Gusd Detailes
                        gusdDate='02/12/2023'
                        accountNumber='98745211'
                        dateOfBoardMeeting='26/09/98'
                        BoardItem='Board'
                        pageItem='page'
                        superintendentAssistent='Mahesh'
                      /> */}
                    </div>
                  </div>
                </div>
                {/*col*/}
                <div className='custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2'>
                  <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
                  <span>Add e Signature</span>
                </div>
                {/*col*/}
                <div className='grid grid-cols-3 gap-2'>
                  <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
                  <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
                  <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer '
                   onClick={() => {
                    approveSelectedReport(specificReportDetailsEdit?.PSATransactionCycleData?.report_Id)
                    setReport_Approved(true)
                  }}
                    ><i className='pi pi-check'></i><span>Approve</span></div>
                </div>

              </div>
            </Sidebar>

            <Dialog header="Header" className='RejectReport' visible={RejectReport} style={{ width: '30vw' }} onHide={() => setRejectReport(false)}>
              <div className='p-[22px] space-y-[14px]'>
                {/*col*/}
                <div>
                  <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
                </div>
                {/*col*/}
                <div className='space-y-1'>
                  <div className='text-[#344054] font-medium text-xs'>Enter the reason for rejection</div>
                  <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Reason for Rejection' style={{ border: '1px', borderStyle: "solid", borderRadius: '5px', borderColor: "#E4E7EC", background: "#fff", width: '100%' }} />
                </div>
                {/*col*/}
                <div className='flex items-center justify-center'>
                  <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(true)}>Send</div>
                </div>
                {/*col*/}
              </div>
            </Dialog>

            <Dialog header="Header" className='RejectReport' visible={RejectReport_Send} style={{ width: '30vw' }} onHide={() => setRejectReport_Send(false)}>
              <div className='p-[22px] space-y-[14px]'>
                {/*col*/}
                <div>
                  <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
                </div>
                {/*col*/}
                <div className='space-y-1'>
                  <div className='text-[#249144] font-normal text-base'>Message sent successfully!</div>
                  <InputText disabled value={value} onChange={(e) => setValue(e.target.value)} placeholder='Information Missing for  "David", Please review and resubmit.' style={{ border: '1px', borderStyle: "solid", borderRadius: '5px', borderColor: "#F2F4F7", background: "#F2F4F7", width: '100%' }} />
                </div>
                {/*col*/}
                <div className='flex items-center justify-center'>
                  <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(false)}>ok</div>
                </div>
                {/*col*/}
              </div>
            </Dialog>

            <Dialog header="Header" className='RejectReport' visible={Report_Approved} style={{ width: '30vw' }} onHide={() => setReport_Approved(false)}>
              <div className='p-[22px] space-y-[14px]'>
                <div className='flex justify-end'>
                  <div className='text-[#667085] text-sm cursor-pointer' onClick={() => setReport_Approved(false)}><i className='gusd-close'></i></div>
                </div>
                <div className='flex items-center justify-center'>
                  <div className='text-[#0487C8] font-medium text-lg flex items-center gap-2'><span className='right-rounded block w-[20px] h-[20px]'></span><span>Selected report was Approved</span></div>
                </div>
                {/*col*/}
                <div className='flex items-center justify-center'>
                  <div className='text-[#1E3E5A] border border-[#C8C8C8] py-2 px-4 text-center rounded-lg cursor-pointer' onClick={() => setReport_Approved(false)}>Close</div>
                </div>
                {/*col*/}
              </div>
            </Dialog>

            <Sidebar className='PSAviewPopup' visible={StipendsFormFullScreen} position="right" onHide={() => setStipendsFormFullScreen(false)} style={{ width: '60vw', background: '#F5F6F7' }}>
              <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
                <div className='cursor-pointer mb-[20px]' onClick={() => setStipendsFormFullScreen(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div>

                <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
                  <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                    <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement

                      .pdf</span>
                  </div>
                  <div className='text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer' onClick={() => setStipendsFormFullScreen(false)}><span className='Exit_Full_Screen block w-[18px] h-[18px]'></span><span>Exit Full Screen</span></div>
                </div>

                <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
                  <div className='lg:h-[25vw] overflow-auto'>
                    {/* <PsaPdf
                      agreementDate='26/09/98'
                      partyName='BlueOrbit'
                      amount='2016'
                      services='lunch dinner free'
                      effectiveDate='02/09/1998'
                      expirationDate='06/09/1998'
                      typeOfBusinessEntityAandN='Insaurance Form'
                      submittedTo='30/06/2023'
                      referenceNo='33'

                      // PSA Consultant details
                      typeOfBusinessEntityPartyDetails='Individual'
                      licenseNumber='LE02145'
                      addressPSa='USA'
                      psaDate='03/25/2024'
                      contactNumber='9823456988'
                      fax='66665'

                      //Tax Identification Details
                      socialSecurityNumber='30'
                      employerIdentification='This is Employer Identification'

                      //Gusd Detailes
                      gusdDate='02/12/2023'
                      accountNumber='98745211'
                      dateOfBoardMeeting='26/09/98'
                      BoardItem='Board'
                      pageItem='page'
                      superintendentAssistent='Mahesh'
                    /> */}
                  </div>
                </div>

                {/*col*/}
                <div className='custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2 py-[20px]'>
                  <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
                  <span>Add e Signature</span>
                </div>
                {/*col*/}

                <div className='grid grid-cols-3 gap-2'>
                  <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
                  <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
                  <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer btn-deactivate' onClick={() => setReport_Approved(true)}><i className='pi pi-check'></i><span>Approve</span></div>
                </div>

              </div>
            </Sidebar>

          </Layout >
        )
        }
      </ReactFullscreen>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}